/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { userDataRoleSchema } from './UserDataRoleSchema'

export const userDataSchema = z.object({
	userId: z.string(),
	role: userDataRoleSchema,
	avatarUrl: z.string().nullable(),
	name: z.string().nullable(),
	email: z.string().nullable(),
	joinedAt: z.iso.datetime(),
	permissions: z.array(z.string()).nullable().default([]),
})

export type UserDataSchema = z.infer<typeof userDataSchema>
